import { useLayoutEffect, useMemo, useSyncExternalStore } from "react";
import { LiveReviewDraft } from "../../../../backend/src/shared/liveReviewDraft";

// Keep React imports inside this app: importing the mobile hook can resolve
// backend/node_modules/react and create a second React instance in Bun's bundle.
export function useLiveReviewDraft<T extends object>(id: string, remote: T, save: (patch: Partial<T>, value: T) => Promise<void>) {
  const writer = useMemo(() => new LiveReviewDraft(remote, save), [id]);
  writer.save = save;
  useLayoutEffect(() => writer.reconcile(remote), [writer, remote]);
  const snapshot = useSyncExternalStore(writer.subscribe, writer.read);
  return { ...snapshot, change: writer.change, retry: writer.flush };
}
